import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconGarage"><Path fillRule="evenodd" clipRule="evenodd" d="M10.7908 3.34693C11.5433 2.93107 12.4567 2.93107 13.2092 3.34693L20.7092 7.49167C21.5056 7.93178 22 8.76985 22 9.67977V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V9.67977C2 8.76985 2.49438 7.93178 3.29078 7.49167L10.7908 3.34693ZM7 19H17V16H7V19ZM7 15H17V13.5C17 12.6715 16.3284 12 15.5 12H8.5C7.67157 12 7 12.6715 7 13.5V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGarage;
